import React from "react";
import Form from "react-validation/build/form";
import axios from "axios";

import TextArea from "../../components/TextArea";
import { ValidationProvider } from "../../validation/validation-provider";
import { BACKEND_CONFIG } from "../../config/consts";
import closeIcon from "../../images/icon-trash.svg";
import FileToUpload from "../../components/FileToUpload";

class NotesForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      note: "",
      left: 78,

      fileToUpload: null,
      uploadProgress: 0,
      isLoading: false,

      uploadFile: null,
    };

    this.formRef = React.createRef();

    this.updateData = this.updateData.bind(this);
    this.charactersLeft = this.charactersLeft.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDeleteFileToUpload = this.handleDeleteFileToUpload.bind(this);
  }

  updateData = (e) => {
    const field = e.target.name;

    this.setState({ [field]: e.target.value });
  };

  charactersLeft = (e) => {
    this.setState({ left: 78 - e.target.value.length });
  };

  handleSelectFile(file) {
    if (file != null)
      this.parseInBase64(file).then((base64) => {
        this.setState({
          fileToUpload: {
            FileName: file.name,
            ContentType: file.type,
            Content: base64,
            Partition: this.props.clientId,
          },
          isLoading: false,
          uploadProgress: 0,
        });

        this.uploadFile();
      });
  }

  parseInBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }

  uploadFile() {
    this.setState({ isLoading: true });

    axios
      .post(
        `${BACKEND_CONFIG.apiUrl}/documents/${this.props.clientId}/files`,
        this.state.fileToUpload,
        {
          onUploadProgress: (ProgressEvent) => {
            this.setState({
              uploadProgress:
                (ProgressEvent.loaded / ProgressEvent.total) * 100,
            });
          },
        }
      )
      .then((data) => {
        this.handleUploadFile({
          Name: this.state.fileToUpload.FileName,
          Id: data.data.FileId,
        });
        this.handleDeleteFileToUpload();
      });
  }

  handleUploadFile(file) {
    this.setState({
      uploadFile: file,
    });
  }

  handleDeleteUploadedFile() {
    axios.delete(
      `${BACKEND_CONFIG.apiUrl}/documents/${this.props.clientId}/files/${this.state.uploadFile.Id}`
    );

    this.setState({
      uploadFile: null,
    });
  }

  handleDeleteFileToUpload() {
    this.setState({ fileToUpload: null, isLoading: false });
    this.fileinput.value = "";
  }

  handleSubmit() {
    let isValid = ValidationProvider.isValid(this.formRef);

    if (!isValid) {
      return;
    }

    var noteData = {
      Text: this.state.note,
      AttachmentId: this.state.uploadFile ? this.state.uploadFile.Id : null,
    };

    function handleError(error) {
      let errorResponse = error.data;

      if (errorResponse && errorResponse.ValidationErrors) {
        this.props.onServerValidationErrors(
          error.response.data.ValidationErrors
        );
      } else {
        this.props.onFail();
      }
    }

    axios({
      url: `${BACKEND_CONFIG.apiUrl}clients/${this.props.clientId}/policies/${this.props.policyId}/notes`,
      method: "post",
      data: JSON.stringify(noteData),
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (response.data.Response.Response.Successful) {
          this.props.onSuccess();
        } else {
          handleError.call(this, response);
        }
      })
      .catch((error) => {
        handleError.call(this, error);
      });
  }

  render() {
    const uploadBtn = this.state.fileToUpload == null &&
      !this.state.uploadFile && (
        <button
          className="btn btn-default"
          onClick={() => this.fileinput.click()}
        >
          Select a File
        </button>
      );

    return (
      <div>
        <span className="file-add-label">Attach a document (optional)</span>
        {this.state.uploadFile && (
          <div>
            <div className="uploaded-files">
              <div className="file-label">
                <p className="file-name">{this.state.uploadFile.Name}</p>
                <div className="progress-control">
                  <img
                    src={closeIcon}
                    alt=""
                    onClick={() => this.handleDeleteUploadedFile()}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
        {this.state.fileToUpload && (
          <FileToUpload
            file={this.state.fileToUpload}
            onClick={this.handleDeleteFileToUpload}
            progress={this.state.uploadProgress}
            isLoading={this.state.isLoading}
          />
        )}

        {uploadBtn}

        <div style={{ display: "none" }}>
          <input
            type="file"
            name="file"
            id="file"
            ref={(input) => (this.fileinput = input)}
            onChange={(e) => this.handleSelectFile(e.target.files[0])}
          />
        </div>

        <Form ref={this.formRef}>
          <div className="form-group">
            <span className="hint">
              characters remaining: {this.state.left}
            </span>
            <label htmlFor="note">Add a note to underwriter:</label>
            <TextArea
              value={this.state.note}
              type="text"
              id="note"
              field="text"
              maxlength="78"
              name="note"
              placeholder="Cannot exceed 78 characters"
              onChange={this.charactersLeft}
              onBlur={this.updateData}
            />
          </div>
          <button
            type="button"
            className="btn btn-primary"
            disabled={
              !(this.state.left < 78 || this.state.uploadFile) ||
              this.state.isLoading
            }
            onClick={this.handleSubmit}
          >
            Submit
          </button>
        </Form>
        <div className="delimeter" />
      </div>
    );
  }
}

export default NotesForm;
